module.exports = __webpack_public_path__ + "img/miinimize.460b7bde.svg";